import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = makeStyles((theme: MuiTheme) =>
  createStyles({
    ticketRowType: {
      display: 'flex',
      flexDirection: 'row',
      background: 'transparent',
      margin: '0px 12px 0px 0px',
      flexWrap: 'nowrap',
      flex: '1',
      '& > *': {
        [theme.breakpoints.only('lg')]: {
          fontSize: '30px',
          width: '145px'
        }
      }
    },
    cityPassImage: {
      height: '90px',
      marginRight: '16px'
    }
  })
);
